<template>
  <t-notification></t-notification>
  <header>
    <BoutiqueHeader/>
  </header>
  <div class="top-margin-value">
    <slot />
  </div>
  <footer><TFooter></TFooter></footer>

  <Dialog v-model:visible="display" :modal="true">
    Network was interrupted while re-authenticating. Do you want to retry?
    <template #footer>
      <TButton @click= 'closeDialog()' label="No" class="p-button p-component secondary-color"/>
      <TButton @click = 'refreshToken(timer)' label="Yes" autofocus class="p-button p-component primary-color"/>
    </template>
  </Dialog>

</template>

<script>

import TButton from "./../../common/components/buttons/TButton";
import TNotification from "./../components/TNotification";
import {REFRESH_TOKEN} from '../../domains/authentication/store/actions';
import GeneralVariables from '../utils/GeneralVariables';

import { defineAsyncComponent } from 'vue'
const Dialog = defineAsyncComponent(() =>
  import('primevue/dialog')
)
const TFooter = defineAsyncComponent(() =>
  import('./../../common/components/layouts/footer/TFooter')
)

const BoutiqueHeader = defineAsyncComponent(() =>
  import('./../../domains/boutique/components/BoutiqueHeader')
)
const SECOND_TO_MILLISECONDS = 1000
const MINUTES_TO_SECONDS = 60
export default {
  setup() {},
  components: {
    TFooter,
    TButton,
    TNotification,
    Dialog,
    BoutiqueHeader,
  },
  methods:
  {
 
    refreshToken(timer){
      let This = this
      this.$store.dispatch(REFRESH_TOKEN).then(
        ()=>{
          This.display = false
          timer.active = true
        }
      ).catch(
        (error)=>{
          if (error.message=="Network Error"||error.status==408){
            This.display = true
            timer.active = false
          } 
        }
      )
    },
    refreshTokenIfTimerExpired(timer,timeStep)
    {
      if (Date.now()-localStorage.getItem("refreshTime")>timeStep&&timer.active&&localStorage.getItem("refresh_token")!=null)
      {
        timer.active = false
        this.refreshToken(timer)
      }
    },
    closeDialog()
    {
      this.display = false
    }
  },
  data(){
    return{
      display:false,
      timer:{},
    }
  },
  mounted()
  {
    
    let This = this
    this.timer.active = true
    let timeStep = GeneralVariables.TOKEN_REFRESH_TIME_IN_MINUTES*MINUTES_TO_SECONDS*SECOND_TO_MILLISECONDS
  
    window.addEventListener("mousemove",function(){
        This.refreshTokenIfTimerExpired(This.timer,timeStep)
      }
    )
    window.addEventListener("keydown",function(){
        This.refreshTokenIfTimerExpired(This.timer,timeStep)
      }
    )
    window.addEventListener('touchmove', function(){
        This.refreshTokenIfTimerExpired(This.timer,timeStep)
    })
  }
};
</script>

<style scoped>
.top-margin-value {
  margin-top: 50px;
}

@media screen and (max-width: 1050px) {
  .top-margin-value {
    margin-top: 0px;
  }
  
}

@media screen and (max-width: 900px) {
  .top-margin-value {
    margin-top: 100px;
  }
  
}

@media screen and (max-width: 650px) {
  .top-margin-value {
    margin-top: 150px;
  }
  
}
</style>
